export default {
	APW_MANAGEMENT: 'companies/:company_id/apw-management/',
	APW_SETTING: 'companies/:company_id/apw-management/settings/',
}
